export class MicPermissionError extends Error {
  constructor(
    public readonly code: 'mic_denied' | 'mic_unsupported' | 'mic_failed',
    message: string,
  ) {
    super(message);
    this.name = 'MicPermissionError';
  }
}

export async function ensureMicPermission(): Promise<true> {
  if (!navigator?.mediaDevices?.getUserMedia) {
    throw new MicPermissionError('mic_unsupported', 'Browser does not support getUserMedia');
  }
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true, video: false });
    stream.getTracks().forEach((t) => t.stop());
    return true;
  } catch (err) {
    if (err instanceof Error && (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError')) {
      throw new MicPermissionError('mic_denied', 'Microphone permission denied');
    }
    throw new MicPermissionError('mic_failed', err instanceof Error ? err.message : 'mic init failed');
  }
}
